module.exports = __webpack_public_path__ + "img/black_square_desktop.92ff03f3.png";